import { Button } from "./button";
import { TextInput } from "./text-input";

type MultiValueInputProps = {
  id?: string;
  values: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
  addButtonLabel?: string;
  removeButtonLabel?: string;
  itemAriaLabel?: (index: number) => string;
  disabled?: boolean;
  minItems?: number;
};

function updateListValue(values: string[], index: number, next: string) {
  return values.map((value, valueIndex) => (valueIndex === index ? next : value));
}

function removeListValue(values: string[], index: number) {
  return values.filter((_, valueIndex) => valueIndex !== index);
}

export function MultiValueInput({
  id,
  values,
  onChange,
  placeholder,
  addButtonLabel = "Add item",
  removeButtonLabel = "Remove",
  itemAriaLabel,
  disabled = false,
  minItems = 0,
}: MultiValueInputProps) {
  return (
    <div className="cf-multi-value">
      {values.map((value, index) => {
        const inputId = index === 0 ? (id ?? undefined) : id ? `${id}-${index + 1}` : undefined;
        return (
          <div className="cf-multi-value-row" key={`multi-value-${index}`}>
            <TextInput
              id={inputId}
              value={value}
              onChange={(event) =>
                onChange(updateListValue(values, index, event.currentTarget.value))
              }
              aria-label={itemAriaLabel?.(index)}
              placeholder={placeholder}
              disabled={disabled}
            />
            <Button
              type="button"
              size="sm"
              variant="outline"
              tone="danger"
              disabled={disabled || values.length <= minItems}
              onClick={() => onChange(removeListValue(values, index))}
            >
              {removeButtonLabel}
            </Button>
          </div>
        );
      })}
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={disabled}
        onClick={() => onChange([...values, ""])}
      >
        {addButtonLabel}
      </Button>
    </div>
  );
}
